// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2W_VX","approved":"Status_approved__hTDzu","rejected":"Status_rejected__HDDCQ","expired":"Status_expired__2eKou","label":"Status_label__3FXN6"};